module.exports = {
      id: "comm-gadgets-usage",
      viewBox: "0 0 320 56.865",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-gadgets",
      toString: function () {
        return this.url;
      }
    }